import { toast } from "../../../utils/helpers";
import { aCantidadBase, describirCantidad } from "../../../utils/unidades";


export const useChecks = (facturaProductos) => {
    const checkExistenciaProducto = (producto) => {
        if (!producto.inventariable || producto.cantidad === null) return true;

        if(producto.cantidad != null && producto.cantidad <= 0) {
            toast(`Este producto no tiene existencia (${describirCantidad(producto.cantidad, producto)})`, "error");
            return false;
        }
        return true;
    }

    // `existencia` y `cantidad` van ambas en unidad base — la existencia del
    // producto siempre lo está, y el llamador convierte la cantidad de la línea
    // con `aCantidadBase`. `linea` es la línea de la factura, de donde sale el
    // empaque con que decir ambas también en empaques.
    const checkQuantityConstrains = (existencia, cantidad, linea = null) => {
        if (existencia === null) return true;

        const producto = linea?.producto;
        const unidadLinea = linea?.factor > 1 ? { value: linea.unidad, factor: linea.factor } : null;
        const describir = (valor) => describirCantidad(valor, producto, unidadLinea);

		if(existencia && cantidad && existencia < cantidad) {
			toast(`Existencia Actual ${describir(existencia)}. Solicitado ${describir(cantidad)}`, "error");
			return false;
		}
		if(existencia && existencia <= 0) {
			toast(`Cantidad Debe ser mayor a 0`, "error");
			// onChangeInput("cantidad", 1);
			return false;
		}

        return true;
	};

    const checkProductoRepetidoFactura = (productoId, index) => {
        const indiceProducto = facturaProductos.findIndex(
            (producto) => producto.producto_id === productoId
        );

        const linea = facturaProductos[indiceProducto];

        // Repetir el producto suma 1 a la cantidad de la línea, que va en la
        // unidad de la línea (1 CAJA, no 1 UND). La existencia está en unidad
        // base, así que la comparación se hace ahí: sin convertir, un producto
        // con 10 UND dejaba pasar una segunda CAJA de 12.
        const cantidadEnBase = aCantidadBase(linea?.cantidad + 1, linea?.factor ?? 1);

        if (!checkQuantityConstrains(linea?.cantidadAnterior, cantidadEnBase, linea)) {
            facturaProductos.splice(index, 1);
            return;
        }

        if (indiceProducto >= 0 && indiceProducto !== index) {
            facturaProductos[indiceProducto].cantidad += 1;
            facturaProductos.splice(index, 1);
            toast(`Este producto ya ha sido agregado`, "error");
        }
    };

    const checkProductoRepetido = (productoId, index) => {
        const indiceProducto = facturaProductos.findIndex(
            (producto) => producto.producto_id === productoId
        );

        if (indiceProducto >= 0 && indiceProducto !== index) {
            facturaProductos[indiceProducto].cantidad += 1;
            facturaProductos.splice(index, 1);
            toast(`Este producto ya ha sido agregado`, "error");
        }
    };

    return {checkProductoRepetido, checkProductoRepetidoFactura, checkExistenciaProducto, checkQuantityConstrains}
};
